<script>
export default {
    name: 'BackupPricingPlanRequirement',
};
</script>

<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router/composables';
import ServicePlanRequirement from '@/components/payments/components/service-plan/components/requirement';

const emit = defineEmits({
    click: null,
});

const router = useRouter();
const pricingRoute = computed(() => ({ name: 'backupPricing', params: { backupId: router.currentRoute.params.backupId } }));

function click() {
    emit('click');
}
</script>

<template>
    <service-plan-requirement
        :pricing-route="pricingRoute"
        @click="click"
    >
        <slot />
    </service-plan-requirement>
</template>
